export enum TypeBracketCodeEnum {
  SIMPELEM = 'SIMPELEM',
  DOUBLELEM = 'DOUBLELEM',
  POULSIMPLELEM = 'POULSIMPLELEM',
  POULDOUBLELEM = 'POULDOUBLELEM',
  POULBO = 'POULBO',
  LIG = 'LIG',
  LIGBO = 'LIGBO',
}
